import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
} from '@mui/material';
import BeatLoader from 'react-spinners/BeatLoader';

function StockTable({ stockData, onReturn,onEdit }) {
  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table aria-label="stock table">
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: 'bold' }}>Item Name</TableCell>
            <TableCell style={{ fontWeight: 'bold' }}>Stock Quantity</TableCell>
            <TableCell style={{ fontWeight: 'bold' }}>Last Stock In Date</TableCell>
           
          </TableRow>
        </TableHead>
        <TableBody>
          {stockData.length > 0 ? (
            stockData.map((row) => (
              <TableRow key={row.stockId}>
                <TableCell>{row.itemname}</TableCell>
                <TableCell>{row.stock}</TableCell>
                <TableCell>{row.stockindate}</TableCell>
             
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={onReturn ? 6 : 5} align="center">
                <center><BeatLoader color="#9E1713" /></center>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  {/** Optionally, display a message when there's no data */}
                  {/** If you're using loading state elsewhere, adjust accordingly */}
                  No stock data available.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default StockTable;
